import * as React from "react";
import clsx from "clsx";
import * as s from "./DropdownMenu.style.css";

export interface MenuItemProps {
  value: string;
  children: React.ReactNode;
  selected?: boolean;
  disabled?: boolean;
  title?: string;
  onClick?: () => void;
}

export const MenuItem = React.forwardRef<HTMLButtonElement, MenuItemProps>(
  ({ value, children, selected = false, disabled = false, title, onClick }, ref) => {
    return (
      <button
        ref={ref}
        className={clsx(s.menuItem, selected && s.menuItemSelected, disabled && s.menuItemDisabled)}
        onClick={
          disabled
            ? undefined
            : (e) => {
                e.stopPropagation();
                onClick?.();
              }
        }
        onMouseDown={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        role="menuitem"
        aria-disabled={disabled || undefined}
        title={title}
        type="button"
      >
        {children}
      </button>
    );
  }
);

MenuItem.displayName = "MenuItem";
